/** @jsxImportSource @emotion/react */
import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Stack,
    Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const SearchResultArea = ({ showReverse, revRoadAddr, revJibunAddr, coord }) => {
    
    const getResult = () => {
        let result = [];
        if (showReverse) {
            if (revRoadAddr) {
                result = [{ label: '도로명 주소', value: revRoadAddr }];
            } else {
                result = [{ label: '지번 주소', value: revJibunAddr }];
            }
        } else {
            result = [
                { label: 'X 좌표', value: coord.x },
                { label: 'Y 좌표', value: coord.y },
            ]
        }
        return result;
    };

    return (
        <Paper variant="outlined" sx={{ p: 1.5, border: '1px solid #EBF6FF', borderRadius: 0, bgcolor: '#EBF6FF', mb: 6, }}>
            <Stack
                direction="row" 
                alignItems="center" 
                spacing={0.5} 
                sx={{ mb: 1.5 }}
            >
                <InfoIcon 
                    fontSize="small" 
                    sx={{ color: '#007ed0' }} 
                />
                
                {/* 텍스트 */}
                <Typography 
                    variant="subtitle1" 
                    fontWeight={700}
                >
                    검색 결과
                </Typography>
            </Stack>
            <Stack spacing={0.5} sx={{ ml: 0.5 }}>
                {getResult().map((item) => (
                    <Box
                        key={item.label}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            {item.label}
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {item.value}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
};

export default SearchResultArea;